<template>
  <div class="lesson-block main-block">
    <div
      v-if="!isEditLocal"
      class="lesson-block__content"
    >
      <template v-if="isPreviewImg">
        <div
          v-if="!isVideoStart"
          class="lesson-block__video-wrapper-preview"
        >
          <img :src="previewImg">
          <Icon
            class="width-40px position-absolute"
            icon="video-start"
            @click="startVideo"
          />
        </div>
        <div
          v-else
          class="lesson-block__video-wrapper"
        >
          <iframe
            class="lesson-block__video"
            :src="createVideoSrc + '?rel=0&amp;autoplay=1'"
            frameborder="0"
            allowfullscreen="allowfullscreen"
            allow="autoplay; encrypted-media; picture-in-picture"
          />
        </div>
      </template>
      <div
        v-else
        class="lesson-block__video-wrapper"
      >
        <iframe
          class="lesson-block__video"
          :src="createVideoSrc"
          frameborder="0"
          allowfullscreen="allowfullscreen"
          allow="autoplay; encrypted-media; picture-in-picture"
        />
      </div>
    </div>
    <div
      v-if="isEditLocal"
      class="lesson-block__content"
    >
      <Input
        v-model="linkValue"
        class="lesson-block__edit"
        :error="isError && 'Ссылка на видео должна быть от Vimeo или YouTube'"
        title="Ссылка на видео"
      />
      <div
        v-if="isLoadingPreview"
        class="lesson-block__preview"
      >
        <div class="ajax__line ajax__line-preview" />
      </div>
      <template v-else-if="!isPreviewImg">
        <div
          v-if="isPreview"
          class="lesson-block__preview"
        >
          <Icon
            class="lesson-block__preview-close"
            icon="close"
            @click="isPreview = false"
          />
          <img
            v-if="typeId === 1"
            :src="createPosterSrc"
          >
          <iframe
            v-else
            class="vimeo__frame"
            :src="`https://player.vimeo.com/video/${videoId}?controls=false`"
          />
        </div>
      </template>
      <template v-else>
        <div
          v-if="isPreviewImg"
          class="lesson-block__preview"
        >
          <Icon
            class="lesson-block__preview-close"
            icon="close"
            @click="isPreviewImg = false"
          /><img :src="previewImg">
        </div>
      </template>
      <div class="lesson-block__buttons">
        <Button
          class="-xs-"
          :is-loading="isLoading"
          @click="saveBlock"
        >
          Сохранить
        </Button>
        <ButtonCancel
          class="-xs- hover__link"
          @click="cancel"
        >
          Отмена
        </ButtonCancel>
        <UploadFiles
          class="-xs-"
          button-text="Добавить превью"
          only-images
          @getFiles="addPreview"
        />
      </div>
    </div>
    <ControlsArrow
      v-if="$permissionsUpdate"
      class="lesson__controls"
      :first-block="isFirstBlock"
      :last-block="isLastBlock"
      @moveUp="moveUp"
      @moveDown="moveDown"
    />
    <OptionsList
      v-if="optionsFields.length"
      class="course-lesson__options"
      :options-fields="optionsFields"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import blockPermissionMixin from '@/views/Courses/Lesson/components/block.permission.mixin';
import matchServiceByUrl from '@/functions/matchServiceByUrl';

export default {
  mixins: [blockPermissionMixin],
  props: {
    permissions: {},
    isEdit: {
      default: false,
      type: Boolean
    },
    content: {},
    arrows: {
      default: true,
      type: Boolean
    },
    isFirstBlock: {
      default: false,
      type: Boolean
    },
    isLastBlock: {
      default: false,
      type: Boolean
    },
    isLoading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      previewImg: '',
      videoId: '',
      linkLocal: '',
      linkValue: '',
      typeId: 1,
      isError: false,
      isEditLocal: false,
      isPreview: true,
      isPreviewImg: false,
      isLoadingPreview: false,
      isVideoStart: false
    };
  },
  computed: {
    optionsFields() {
      const arr = [];
      if (this.$permissionsUpdate) {
        arr.push({
          text: 'Редактировать',
          func: this.openBlockEdit,
          icon: 'edit'
        });
      }
      if (this.$permissionsCreate) {
        arr.push({
          text: 'Дублировать',
          func: this.duplicateBlock,
          icon: 'copy'
        });
      }
      if (this.$permissionsDelete) {
        arr.push({
          text: 'Удалить',
          func: this.deleteBlock,
          icon: 'delete',
          iconWidth: '10px',
          confirm: true,
          confirmTitle: 'Вы уверены, что хотите удалить этот блок?',
          confirmDescription: 'Блок будет удален навсегда',
          confirmApplyText: 'Удалить',
          confirmCancelText: 'Отменить',
          red: true
        });
      }

      return arr;
    },
    createPosterSrc() {
      return `https://img.youtube.com/vi/${this.videoId}/maxresdefault.jpg`;
    },
    createVideoSrc() {
      if (this.typeId === 1) {
        return `https://www.youtube.com/embed/${this.videoId}`;
      }

      return `https://player.vimeo.com/video/${this.videoId}`;
    }
  },
  watch: {
    linkValue(val) {
      this.contentLocal.videoUrl = val;
      this.videoId = this.getVideoId(val);
    },
    isEditDefault() {
      this.isEditLocal = this.isEdit;
    },
    isPreviewImg(val) {
      if (!val) {
        this.contentLocal.img = null;
      }
    },
    content() {
      this.setData();
    }
  },
  mounted() {
    this.setData();

    if (this.contentLocal.forceEdit) {
      this.isEditLocal = true;
      delete this.contentLocal.forceEdit;
    }
  },
  methods: {
    setData() {
      this.videoId = this.getVideoId(this.content.videoUrl);
      this.contentLocal = _.cloneDeep(this.content);
      this.linkValue = this.contentLocal.videoUrl;
      if (this.content && this.content.img.url) {
        this.loadPreview();
      }
    },
    getVideoId(url) {
      const matchedService = matchServiceByUrl(url);
      this.isError = false;

      if (matchedService.name === 'vimeo') {
        this.typeId = 2;
        return matchedService.data[1].length >= 1 ? matchedService.data[1] : false;
      } else if (matchedService.name === 'youtube') {
        this.typeId = 1;
        return matchedService.data[1].length === 11 ? matchedService.data[1] : false;
      } else {
        this.isError = true;
        return null;
      }
    },
    openBlockEdit() {
      this.isEditLocal = true;
    },
    deleteBlock() {
      this.$emit('deleteBlock');
    },
    saveBlock() {
      if (this.isError) {
        return;
      }

      setTimeout(() => {
        this.isEditLocal = false;
      }, 1000);
      this.contentLocal.typeId = this.typeId;

      this.$emit('saveBlock', this.contentLocal);
    },
    async addPreview({ formData }) {
      this.isLoadingPreview = true;
      const res = await this.$store.dispatch('ajax/uploadImage', { formData });
      if (res) {
        this.contentLocal.img = { ...res };
      }
      this.loadPreview();
    },
    loadPreview() {
      this.isPreviewImg = true;
      this.previewImg = this.contentLocal.img.url;
      this.isLoadingPreview = false;
    },
    startVideo() {
      this.isVideoStart = true;
    },
    cancel() {
      this.isEditLocal = false;
      this.setData();
    },
    duplicateBlock() {
      this.$emit('duplicateBlock');
    },
    moveUp() {
      this.$emit('moveUp');
    },
    moveDown() {
      this.$emit('moveDown');
    }
  }
};
</script>
